import docLinks from '@/locale/documents.json'

export function useDocLinks() {
  return docLinks
}
